import { useMemo } from 'react';
import { isEmpty } from 'underscore';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';

export const getInitialCurrentLimits = (currencyCode) => [
    {
        amount: {
            amount: '9223372036854775807',
            currencyCode: currencyCode || 'CHF'
        },
        periodStartDate: '',
        resetDate: '',
        startDate: '',
        remainingLimit: { currencyCode: currencyCode || 'CHF', amount: '9223372036854775807' },
        timePeriod: 'daily'
    }, {
        amount: {
            amount: '9223372036854775807',
            currencyCode: currencyCode || 'CHF'
        },
        periodStartDate: '',
        resetDate: '',
        startDate: '',
        remainingLimit: { currencyCode: currencyCode || 'CHF', amount: '9223372036854775807' },
        timePeriod: 'weekly'
    }, {
        amount: {
            amount: '9223372036854775807',
            currencyCode: currencyCode || 'CHF'
        },
        periodStartDate: '',
        resetDate: '',
        startDate: '',
        remainingLimit: { currencyCode: currencyCode || 'CHF', amount: '9223372036854775807' },
        timePeriod: 'monthly'
    }];

export const INITIAL_ALLOWED_LIMITS = [
    '10',
    '50',
    '100',
    '200',
    '300',
    '500',
    '1000',
    '2000',
    '3000',
    '4000',
    '5000',
    '10000',
    '20000',
    '50000',
    '100000',
    '9223372036854775807'
];

export const useGetDefultDepositLimits = ({ allowedLimits, waitingLimits, currentLimits }) => {
    const userDetails = useUserSelector(prop('userDetails'));

    return useMemo(() => ({
        allowedLimits: isEmpty(allowedLimits) ? INITIAL_ALLOWED_LIMITS : allowedLimits,
        currentLimits: isEmpty(currentLimits) ? getInitialCurrentLimits(userDetails?.currency) : currentLimits,
        waitingLimits
    }), [allowedLimits, currentLimits, userDetails?.currency, waitingLimits]);
};
